/** Matches output of `npm run optimize-images` → `public/images/opt/*.webp` */
export const IMAGE_OPT = '/images/opt';

export const PORTFOLIO_WIDTHS = [640, 960, 1280, 1920] as const;
export const AVATAR_WIDTHS = [160, 320] as const;
export const LOGO_WIDTHS = [88, 176, 264] as const;

export const HOME_HERO_STEM = '4677_better';
export const HOME_HERO_PRELOAD_HREF = `${IMAGE_OPT}/${HOME_HERO_STEM}-1920.webp`;

export function portfolioSrcSet(stem: string): string {
  return PORTFOLIO_WIDTHS.map((w) => `${IMAGE_OPT}/${stem}-${w}.webp ${w}w`).join(', ');
}

export function portfolioImgSrc(stem: string, defaultWidth: 1280 | 1920 = 1280): string {
  return `${IMAGE_OPT}/${stem}-${defaultWidth}.webp`;
}

export function avatarSrcSet(stem: string): string {
  return AVATAR_WIDTHS.map((w) => `${IMAGE_OPT}/${stem}-${w}.webp ${w}w`).join(', ');
}

export function avatarImgSrc(stem: string, defaultWidth: 160 | 320 = 320): string {
  return `${IMAGE_OPT}/${stem}-${defaultWidth}.webp`;
}

export function logoSrcSet(): string {
  return LOGO_WIDTHS.map((w) => `${IMAGE_OPT}/logos-main-${w}.webp ${w}w`).join(', ');
}

export function logoImgSrc(defaultWidth: 88 | 176 | 264 = 176): string {
  return `${IMAGE_OPT}/logos-main-${defaultWidth}.webp`;
}

/** `/images/foo.png` → `foo` for opt/{stem}-{width}.webp */
export function stemFromPublicImagePath(publicPath: string): string {
  const filename = publicPath.split('/').pop() ?? publicPath;
  return filename.replace(/\.(png|jpe?g|webp|heic)$/i, '');
}
